// ** React Imports
import { Link } from "react-router-dom";
import { useSkin } from "@hooks/useSkin";
import { useForm, Controller } from "react-hook-form";
import InputPasswordToggle from "@components/input-password-toggle";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

// ** Reactstrap Imports
import {
  Form,
  Input,
  Label,
  Button,
  CardText,
  CardTitle,
  Card,
  CardBody,
  Spinner,
  FormFeedback,
} from "reactstrap";

// ** Styles
import "@styles/react/pages/page-authentication.scss";
import useUser from "../../../utility/context/useUserContext";
import { useState } from "react";
import { env } from "../../../configs/env";

const defaultValues = {
  password: "",
  loginEmail: "",
};

const Login = () => {
  const { skin } = useSkin();
  const [enviromentSelected, setEnviroment] = useState(
    localStorage.getItem("currentEviroment") ?? "DEV"
  );

  const { singIn, loading, error } = useUser();
  const schema = yup.object().shape({
    password: yup.string().required("password is required"),
    loginEmail: yup.string().email().required("email is required"),
  });
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema) });

  skin === "dark" ? "login-v2-dark.svg" : "login-v2.svg";

  const onSubmit = async (data) => {
    await singIn(data.loginEmail, data.password);
  };

  return (
    <div className="auth-wrapper auth-basic px-2">
      <div className="auth-inner my-2">
        <Card className="mb-0">
          <CardBody>
            <Link
              className="brand-logo"
              to="/"
              onClick={(e) => e.preventDefault()}
            >
              <h2 className="brand-text ms-1">
                <span className="text-primary">NFTY</span>Door
              </h2>
            </Link>
            <CardTitle tag="h4" className="mb-1">
              Welcome to NFTYDoor Loan Officer
            </CardTitle>
            <CardText className="mb-2">Please sign-in</CardText>
            <Form
              className="auth-login-form mt-2"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="mb-1">
                <Label className="form-label" for="loginEmail">
                  Email
                </Label>
                <Controller
                  id="loginEmail"
                  name="loginEmail"
                  control={control}
                  render={({ field }) => (
                    <Input
                      autoFocus
                      type="email"
                      placeholder="john@example.com"
                      invalid={errors.loginEmail}
                      {...field}
                    />
                  )}
                />
                {errors.loginEmail && (
                  <FormFeedback>{errors.loginEmail.message}</FormFeedback>
                )}
              </div>
              <div className="mb-1">
                <div className="d-flex justify-content-between">
                  <Label className="form-label" for="password">
                    Password
                  </Label>
                  <Link to="/forgot-password">
                    <small>Forgot Password?</small>
                  </Link>
                </div>
                <Controller
                  id="password"
                  name="password"
                  control={control}
                  render={({ field }) => (
                    <InputPasswordToggle
                      className="input-group-merge"
                      invalid={errors.password}
                      {...field}
                    />
                  )}
                />
                {errors.password && (
                  <FormFeedback>{errors.password.message}</FormFeedback>
                )}
              </div>
              <div className="form-check mb-1">
                <Input type="checkbox" id="remember-me" />
                <Label className="form-check-label" for="remember-me">
                  Remember Me
                </Label>
              </div>
              {error && <p className="color-danger text-center">{error}</p>}
              <Button disabled={loading} color="primary" block>
                {loading ? (
                  <Spinner
                    style={{ width: 16, height: 16 }}
                    color="secundary"
                  />
                ) : (
                  "Login"
                )}
              </Button>
            </Form>
          </CardBody>
        </Card>
        {process.env.REACT_APP_ENV !== "prod" && (
          <select
            value={enviromentSelected}
            onChange={(e) => {
              localStorage.setItem("currentEnvironment", e.target.value);
              setEnviroment(e.target.value);
              window.location.reload();
            }}
          >
            {Object.keys(env).map((items, index) => (
              <option key={index} value={items}>
                {items}
              </option>
            ))}
          </select>
        )}
      </div>
    </div>
  );
};

export default Login;
